import { CommandData } from "../../command/command";
import { GxmlCommand } from "./gxml-command";
export class RemoveNodeCommand extends GxmlCommand {
    constructor(parent, child, position) {
        super();
        this._parent = parent;
        this._child = child;
        this._position = position;
    }
    get id() {
        return RemoveNodeCommandData.ID;
    }
    get parent() {
        return this._parent;
    }
    get child() {
        return this._child;
    }
    get position() {
        return this._position;
    }
    get changeRoot() {
        return this._parent;
    }
    do() {
        return this._parent.removeNode(this._child);
    }
    undo() {
        this._parent.insertNode(this._child, this._position);
        return true;
    }
    getData() {
        return {
            id: this.id,
            parentId: this._parent.id,
            childId: this._child.id,
            position: this._position
        };
    }
}
export var RemoveNodeCommandData;
(function (RemoveNodeCommandData) {
    RemoveNodeCommandData.ID = 'RemoveNode';
    function is(arg) {
        return CommandData.is(arg)
            && arg.id === RemoveNodeCommandData.ID
            && 'parentId' in arg
            && 'childId' in arg
            && 'position' in arg;
    }
    RemoveNodeCommandData.is = is;
})(RemoveNodeCommandData || (RemoveNodeCommandData = {}));
//# sourceMappingURL=remove-node-command.js.map